module.exports = __webpack_public_path__ + "static/media/howTheWorldGrow-desktop.491acc5c.jpg";